import React from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    title: 'Planner Emocional Anual',
    desc: '12 meses para registrar tu viaje interior. Un espacio simple, bonito y flexible para seguir observándote a lo largo del año, sin fechas fijas ni presiones.',
    value: '$3.990 ARS',
    image: 'https://cdn.magicpatterns.com/uploads/5cgdXdDfWUFsvPFP5FeWEz/Portada_Bono_Planner.webp'
  }, {
    title: '365 Afirmaciones Diarias',
    desc: 'Una para cada día del año. Una biblioteca emocional para sostenerte, inspirarte y reconectar con tu proceso cada vez que lo necesites.',
    value: '$4.990 ARS',
    image: 'https://cdn.magicpatterns.com/uploads/3hpsexvUF7n51iucEhdyVx/Portada_Bono_Afirmaciones_(1).webp'
  }, {
    title: 'Kit de Emergencia Emocional',
    desc: 'Creado para acompañarte justo en esos momentos en los que necesitás bajar revoluciones, volver al presente y darte contención sin abandonar el proceso.',
    value: '$2.990 ARS',
    image: 'https://cdn.magicpatterns.com/uploads/6LEftJWwRF3yhAt65csQbK/Portada_Bono_Kit_emergencia.webp'
  }, {
    title: 'Asistente IA 24/7: Tu Espacio Seguro',
    desc: 'Recibís un prompt especializado que pegás en ChatGPT, Claude o Gemini y tenés acompañamiento emocional gratuito las 24hs mientras hacés el journal. Como tener una compañera que te escucha a las 3am sin juzgarte. Ningún otro journal en el mundo ofrece esto.',
    value: '$6.990 ARS',
    isExclusive: true,
    image: 'https://cdn.magicpatterns.com/uploads/fpHXvZsnKPbJC2dL15qibe/Portada_Bono_Chatgpt.webp'
  }];
  return <Section bgColor="blush" data-id="element-17">
      <div className="max-w-4xl mx-auto" data-id="element-18">
        <div className="text-center mb-16" data-id="element-19">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-violet text-white mb-6" data-id="element-20">
            <Gift className="w-8 h-8" data-id="element-21" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif mb-4 text-[#9C74B4]" data-id="element-22">
            Hoy recibís 4 bonos exclusivos gratis
          </h2>
          <p className="text-brand-dark text-lg max-w-2xl mx-auto" data-id="element-23">
            Además de <strong data-id="element-24">Viaje a tu Interior</strong>, hoy vas a recibir{' '}
            <strong data-id="element-25">4 bonos</strong> pensados para{' '}
            <strong data-id="element-26">acompañarte antes, durante y después de tu proceso</strong>.
            No son extras vacíos. Son <strong data-id="element-27">herramientas</strong> que hacen
            que este viaje sea más sostenido.
          </p>
        </div>

        <div className="space-y-6" data-id="element-28">
          {bonuses.map((bonus, idx) => <div key={idx} className="bg-white rounded-sm shadow-sm overflow-hidden border border-white hover:border-brand-violet/20 transition-colors" data-id="element-29">
              <div className="flex items-center justify-center bg-white p-6 pt-[0px] pb-[0px] pl-[24px] pr-[24px]" data-id="element-30">
                <img src={bonus.image} alt={bonus.title} className="w-48 h-48 object-contain" data-id="element-31" />
              </div>
              <div className="px-6 pb-6 md:px-8 md:pb-8" data-id="element-32">
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 mb-2" data-id="element-33">
                  <h3 className="text-xl font-serif text-brand-dark" data-id="element-34">
                    {bonus.title}
                  </h3>
                  <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-brand-cream/50 rounded-sm border border-brand-violet/10" data-id="element-35">
                    <span className="text-xs text-gray-400 line-through font-medium" data-id="element-36">
                      Valor: {bonus.value}
                    </span>
                    <span className="text-xs font-bold uppercase tracking-wider text-[#9972B8]" data-id="element-37">
                      GRATIS
                    </span>
                  </div>
                </div>
                {bonus.isExclusive && <div className="mb-3" data-id="element-38">
                    <span className="inline-block px-3 py-1 text-xs font-bold uppercase tracking-wider bg-[#4A1D6E] text-[#D4AF37] rounded-sm" data-id="element-39">
                      ✨ EXCLUSIVO✨
                    </span>
                  </div>}
                <p className="text-sm md:text-base text-[#4A4A4A]" data-id="element-40">
                  {bonus.desc}
                </p>
              </div>
            </div>)}
        </div>

        <div className="text-center p-8 bg-brand-violet text-white rounded-sm shadow-lg pt-[32px] pb-[32px] mt-[15px] mb-[15px]" data-id="element-41">
          <p className="text-lg font-medium" data-id="element-42">
            Todo esto hace que{' '}
            <span className="text-[#5A2D7E] font-bold" data-id="element-43">
              Viaje a tu Interior
            </span>{' '}
            no sea solo un journal, sino una experiencia mucho más completa,
            cuidada y transformadora.
          </p>
        </div>

        <div className="text-center mt-6" data-id="element-44">
          <Button className="text-lg px-10 py-5" data-id="element-45">QUIERO EL KIT COMPLETO</Button>
        </div>
      </div>
    </Section>;
}